import styles from "./intro.module.scss";
import React from "react";
import Skills from "../skills/skills.tsx";
import IntroductionHeader from "./intorductionHeader.tsx";
import starsStyles from "./AppStars.module.scss";

export default function Intro() {
  return (
    <>
      <div className={styles.intro}>
        <div id={starsStyles.stars}></div>
        <div id={starsStyles.stars2}></div>
        <div id={starsStyles.stars3}></div>
        <div className={styles.wrapper}>
          <IntroductionHeader />
          <div className={styles.sticky}>
            <Skills />
          </div>
        </div>
      </div>
    </>
  );
}
